import { indexHighlights, tickerItems } from '@/mocks/homeData';

export default function Hero() {
  return (
    <section id="top" className="relative w-full overflow-hidden bg-background-50">
      <div className="grid w-full grid-cols-1 gap-12 px-4 pb-12 pt-12 md:px-10 md:pb-16 md:pt-20 lg:grid-cols-12 lg:gap-10 lg:pt-24">
        <div className="reveal-up lg:col-span-7 lg:pr-8">
          <div className="flex items-center gap-3">
            <span className="h-px w-12 bg-primary-500"></span>
            <span className="text-xs tracking-[0.32em] text-primary-600">COVER STORY · 本期导览</span>
          </div>

          <h2 className="mt-7 font-heading text-4xl font-bold leading-[1.12] tracking-tight text-foreground-950 md:text-6xl lg:text-[72px]">
            把今天值得看的
            <br />
            <span className="text-primary-600">网址与线索</span>
            <br />
            整理成一册
          </h2>

          <p className="mt-8 max-w-xl text-base leading-loose text-foreground-600 md:text-lg">
            黑料网址每天替你翻一遍散落各处的分享，挑出值得花时间的站点，写成可回溯的索引。想找同好，也可以通过私信或群组互换资源，让每一次吃瓜都留得下痕迹。
          </p>

          <ul className="mt-8 flex flex-col gap-3">
            {indexHighlights.map((item) => (
              <li key={item} className="flex items-center gap-3 text-sm text-foreground-700">
                <span className="flex h-5 w-5 items-center justify-center text-primary-500">
                  <i className="ri-check-line text-base"></i>
                </span>
                {item}
              </li>
            ))}
          </ul>

          <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
            <a
              href="#index"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-7 py-3.5 text-sm text-background-50 transition-colors hover:bg-primary-600"
            >
              浏览今日索引
              <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#groups"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-400 px-7 py-3.5 text-sm text-foreground-800 transition-colors hover:border-foreground-900 hover:bg-background-100"
            >
              了解互换方式
            </a>
          </div>
        </div>

        <div className="reveal-up lg:col-span-5" style={{ animationDelay: '120ms' }}>
          <figure className="lg:pl-2">
            <div
              className="relative w-full overflow-hidden rounded-lg border border-background-200 bg-background-200"
              style={{ aspectRatio: '3 / 4' }}
            >
              <img
                src="https://readdy.ai/api/search-image?query=Editorial%20magazine%20cover%20still%20life%20with%20crumpled%20warm%20ivory%20paper%20and%20folded%20newspaper%20sheets%2C%20deep%20crimson%20ribbon%20accent%2C%20dramatic%20angled%20side%20light%2C%20soft%20shadows%2C%20minimal%20art%20direction%2C%20fine%20film%20grain%2C%20muted%20amber%20and%20cream%20palette&width=900&height=1200&seq=hg-cover-018&orientation=portrait"
                alt="黑料网址 本期封面 分享推荐交流"
                title="黑料网址 · 本期封面"
                className="h-full w-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/70 via-foreground-950/10 to-transparent"></div>
              <figcaption className="absolute inset-x-0 bottom-0 p-5 text-background-50 md:p-6">
                <span className="text-[11px] tracking-[0.3em] text-accent-300">COVER · 018</span>
                <p className="mt-3 font-heading text-lg leading-snug md:text-xl">
                  本期聚焦：如何判断一条线索是否值得深挖
                </p>
              </figcaption>
            </div>
            <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i> 2026.09.12 更新
              </span>
              <span className="hidden h-3 w-px bg-background-300 sm:inline-block"></span>
              <span className="flex items-center gap-1.5">
                <i className="ri-timer-line"></i> 阅读约 6 分钟
              </span>
            </div>
          </figure>
        </div>
      </div>

      <div className="w-full border-y border-background-200 bg-background-100">
        <div className="flex w-full items-center gap-4 overflow-hidden px-4 py-4 md:px-10">
          <span className="flex shrink-0 items-center gap-2 whitespace-nowrap text-xs tracking-[0.2em] text-primary-600">
            <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
            今日速览
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="ticker-track flex w-max items-center gap-10">
              {[...tickerItems, ...tickerItems].map((item, idx) => (
                <span
                  key={`${item}-${idx}`}
                  className="whitespace-nowrap text-xs text-foreground-600 md:text-sm"
                >
                  {item}
                  <span className="ml-10 text-background-400">/</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}